const equipmentProfile = {
  equipment: "Ausrüstung",
  backbtn: "Geh zurück",
  equipmentTag: "Ausrüstungs-Tag",
  mechanical: "Gleitringdichtungscode",
  customer: "Kunde",
  equipmentType: "Ausstattungsart",
  typeContract: "Vertragsart",
  equipmentStatus: "Asset Status",
  area: "Bereich",
  unit: "Einheit",
  sealTypes: "Gleitringdichtungstypen",
  hazardous: "Gefahrenbereichsklassifizierung",
  createdBy: "Erstellt von",
  dateCreated: "Datum erstellt",
  comment: "Kommentar",
  pumpHousing: "Pumpengehäuse",
  deleteEquipment: "Ausrüstung löschen",
  snackText: "Ihre Datei wurde in den Download-Ordner heruntergeladen"
};
export default equipmentProfile;
